module.exports = __webpack_public_path__ + "img/bw.16dfb7f8.svg";